const FETCH_NOTICES = 'notices/FETCH_NOTICES';

const RESET_NOTICES = 'notices/RESET_NOTICES';

const FETCH_NOTICE = 'notices/FETCH_NOTICE';

export default {
  FETCH_NOTICES,
  RESET_NOTICES,
  FETCH_NOTICE,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/notices/types.js